import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator"; // import { pushDataLayer } from "../../shared/context/gtm-manager";
// import { getGaProductBrand, getGaProductCategory, getGaProductName } from "../gtmConverter";
// import { PaymentType } from "../gtmPayment";
import request from "./request"; // export type ApiSaveQuoteInfoResult = string;
//S3, E1
export function saveQuoteInfo(_x) { return _saveQuoteInfo.apply(this, arguments); } //ST1
function _saveQuoteInfo() { _saveQuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(req) { var resp; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { premium: Number(req.premium), productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context.sent;
            return _context.abrupt("return", resp.data);
        case 4:
        case "end": return _context.stop();
    }
} }, _callee); })); return _saveQuoteInfo.apply(this, arguments); }
export function saveSt1QuoteInfo(_x2) { return _saveSt1QuoteInfo.apply(this, arguments); } //TL1, TL2, TF1, TL3
function _saveSt1QuoteInfo() { _saveSt1QuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(req) { var resp; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            _context2.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { premium: Number(req.premium), productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context2.sent;
            return _context2.abrupt("return", resp.data);
        case 4:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return _saveSt1QuoteInfo.apply(this, arguments); }
export function saveBasicInfo(_x3) { return _saveBasicInfo.apply(this, arguments); }
function _saveBasicInfo() { _saveBasicInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(req) { var resp; return _regeneratorRuntime.wrap(function _callee3$(_context3) { while (1) {
    switch (_context3.prev = _context3.next) {
        case 0:
            _context3.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveBasicInfo/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true, inlineError: true }));
        case 2:
            resp = _context3.sent;
            return _context3.abrupt("return", resp.data);
        case 4:
        case "end": return _context3.stop();
    }
} }, _callee3); })); return _saveBasicInfo.apply(this, arguments); }
export function getHealthQuest(_x4) { return _getHealthQuest.apply(this, arguments); }
function _getHealthQuest() { _getHealthQuest = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(req) { var resp; return _regeneratorRuntime.wrap(function _callee4$(_context4) { while (1) {
    switch (_context4.prev = _context4.next) {
        case 0:
            _context4.next = 2;
            return request.post("/api/v1/quotation/quoteMain/getQuoteInfo/quoteHealthQuestion/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context4.sent;
            return _context4.abrupt("return", resp.data);
        case 4:
        case "end": return _context4.stop();
    }
} }, _callee4); })); return _getHealthQuest.apply(this, arguments); } //TL1, TL2
export function saveHealthQuest(_x5) { return _saveHealthQuest.apply(this, arguments); }
function _saveHealthQuest() { _saveHealthQuest = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee5(req) { var resp; return _regeneratorRuntime.wrap(function _callee5$(_context5) { while (1) {
    switch (_context5.prev = _context5.next) {
        case 0:
            _context5.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveHealthQuest/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context5.sent;
            return _context5.abrupt("return", resp.data);
        case 4:
        case "end": return _context5.stop();
    }
} }, _callee5); })); return _saveHealthQuest.apply(this, arguments); } // Save quote for Health UW questions
export function saveHealthUWQuest(_x6) { return _saveHealthUWQuest.apply(this, arguments); } //TF
function _saveHealthUWQuest() { _saveHealthUWQuest = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee6(req) { var resp; return _regeneratorRuntime.wrap(function _callee6$(_context6) { while (1) {
    switch (_context6.prev = _context6.next) {
        case 0:
            _context6.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveHealthQuest/" + req.productCode, Object.assign({}, req, { state: "saveRefuseHealthQuest", productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context6.sent;
            return _context6.abrupt("return", resp.data);
        case 4:
        case "end": return _context6.stop();
    }
} }, _callee6); })); return _saveHealthUWQuest.apply(this, arguments); }
export function saveTFQuoteInfo(_x7) { return _saveTFQuoteInfo.apply(this, arguments); } //TL1, TL2, TL3
function _saveTFQuoteInfo() { _saveTFQuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee7(req) { var resp; return _regeneratorRuntime.wrap(function _callee7$(_context7) { while (1) {
    switch (_context7.prev = _context7.next) {
        case 0:
            _context7.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { premium: Number(req.premium), productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context7.sent;
            return _context7.abrupt("return", resp.data);
        case 4:
        case "end": return _context7.stop();
    }
} }, _callee7); })); return _saveTFQuoteInfo.apply(this, arguments); }
export function saveTLQuoteInfo(_x8) { return _saveTLQuoteInfo.apply(this, arguments); } // MicroSavings
function _saveTLQuoteInfo() { _saveTLQuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee8(req) { var resp; return _regeneratorRuntime.wrap(function _callee8$(_context8) { while (1) {
    switch (_context8.prev = _context8.next) {
        case 0:
            _context8.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { premium: Number(req.premium), productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context8.sent;
            return _context8.abrupt("return", resp.data);
        case 4:
        case "end": return _context8.stop();
    }
} }, _callee8); })); return _saveTLQuoteInfo.apply(this, arguments); }
export function saveMicroSavingsQuoteInfo(_x9) { return _saveMicroSavingsQuoteInfo.apply(this, arguments); }
function _saveMicroSavingsQuoteInfo() { _saveMicroSavingsQuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee9(req) { var resp; return _regeneratorRuntime.wrap(function _callee9$(_context9) { while (1) {
    switch (_context9.prev = _context9.next) {
        case 0:
            _context9.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { premium: Number(req.premium), productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context9.sent;
            return _context9.abrupt("return", resp.data);
        case 4:
        case "end": return _context9.stop();
    }
} }, _callee9); })); return _saveMicroSavingsQuoteInfo.apply(this, arguments); }
export function save3In1QuoteInfo(_x10) { return _save3In1QuoteInfo.apply(this, arguments); }
function _save3In1QuoteInfo() { _save3In1QuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee10(req) { var resp; return _regeneratorRuntime.wrap(function _callee10$(_context10) { while (1) {
    switch (_context10.prev = _context10.next) {
        case 0:
            _context10.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { premium: Number(req.premium), productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context10.sent;
            return _context10.abrupt("return", resp.data);
        case 4:
        case "end": return _context10.stop();
    }
} }, _callee10); })); return _save3In1QuoteInfo.apply(this, arguments); }
export function saveCi1QuoteInfo(_x11) { return _saveCi1QuoteInfo.apply(this, arguments); }
function _saveCi1QuoteInfo() { _saveCi1QuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee11(req) { var resp; return _regeneratorRuntime.wrap(function _callee11$(_context11) { while (1) {
    switch (_context11.prev = _context11.next) {
        case 0:
            _context11.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { premium: Number(req.premium), productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context11.sent;
            return _context11.abrupt("return", resp.data);
        case 4:
        case "end": return _context11.stop();
    }
} }, _callee11); })); return _saveCi1QuoteInfo.apply(this, arguments); }
export function savePa1QuoteInfo(_x12) { return _savePa1QuoteInfo.apply(this, arguments); }
function _savePa1QuoteInfo() { _savePa1QuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee12(req) { var resp; return _regeneratorRuntime.wrap(function _callee12$(_context12) { while (1) {
    switch (_context12.prev = _context12.next) {
        case 0:
            _context12.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { premium: Number(req.premium), productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context12.sent;
            return _context12.abrupt("return", resp.data);
        case 4:
        case "end": return _context12.stop();
    }
} }, _callee12); })); return _savePa1QuoteInfo.apply(this, arguments); }
export function saveOtcQuoteInfo(_x13) { return _saveOtcQuoteInfo.apply(this, arguments); }
function _saveOtcQuoteInfo() { _saveOtcQuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee13(req) { var resp; return _regeneratorRuntime.wrap(function _callee13$(_context13) { while (1) {
    switch (_context13.prev = _context13.next) {
        case 0:
            _context13.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context13.sent;
            return _context13.abrupt("return", resp.data);
        case 4:
        case "end": return _context13.stop();
    }
} }, _callee13); })); return _saveOtcQuoteInfo.apply(this, arguments); }
export function saveD1QuoteInfo(_x14) { return _saveD1QuoteInfo.apply(this, arguments); }
function _saveD1QuoteInfo() { _saveD1QuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee14(req) { var resp; return _regeneratorRuntime.wrap(function _callee14$(_context14) { while (1) {
    switch (_context14.prev = _context14.next) {
        case 0:
            _context14.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context14.sent;
            return _context14.abrupt("return", resp.data);
        case 4:
        case "end": return _context14.stop();
    }
} }, _callee14); })); return _saveD1QuoteInfo.apply(this, arguments); }
export function saveD2QuoteInfo(_x15) { return _saveD2QuoteInfo.apply(this, arguments); }
function _saveD2QuoteInfo() { _saveD2QuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee15(req) { var resp; return _regeneratorRuntime.wrap(function _callee15$(_context15) { while (1) {
    switch (_context15.prev = _context15.next) {
        case 0:
            _context15.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context15.sent;
            return _context15.abrupt("return", resp.data);
        case 4:
        case "end": return _context15.stop();
    }
} }, _callee15); })); return _saveD2QuoteInfo.apply(this, arguments); }
export function saveD2LQuoteInfo(_x16) { return _saveD2LQuoteInfo.apply(this, arguments); }
function _saveD2LQuoteInfo() { _saveD2LQuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee16(req) { var resp; return _regeneratorRuntime.wrap(function _callee16$(_context16) { while (1) {
    switch (_context16.prev = _context16.next) {
        case 0:
            _context16.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context16.sent;
            return _context16.abrupt("return", resp.data);
        case 4:
        case "end": return _context16.stop();
    }
} }, _callee16); })); return _saveD2LQuoteInfo.apply(this, arguments); }
export function saveM1QuoteInfo(_x17) { return _saveM1QuoteInfo.apply(this, arguments); }
function _saveM1QuoteInfo() { _saveM1QuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee17(req) { var resp; return _regeneratorRuntime.wrap(function _callee17$(_context17) { while (1) {
    switch (_context17.prev = _context17.next) {
        case 0:
            _context17.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context17.sent;
            return _context17.abrupt("return", resp.data);
        case 4:
        case "end": return _context17.stop();
    }
} }, _callee17); })); return _saveM1QuoteInfo.apply(this, arguments); }
export function saveM2QuoteInfo(_x18) { return _saveM2QuoteInfo.apply(this, arguments); }
function _saveM2QuoteInfo() { _saveM2QuoteInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee18(req) { var resp; return _regeneratorRuntime.wrap(function _callee18$(_context18) { while (1) {
    switch (_context18.prev = _context18.next) {
        case 0:
            _context18.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveQuote/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context18.sent;
            return _context18.abrupt("return", resp.data);
        case 4:
        case "end": return _context18.stop();
    }
} }, _callee18); })); return _saveM2QuoteInfo.apply(this, arguments); }
export function saveOcpInfo(_x19) { return _saveOcpInfo.apply(this, arguments); } // export interface ApiSaveEduInfoRequest {
//   quoteNo: string;
//   educationList: [
//     {
//       partyFlag: string;
//       education: string;
//     }
//   ];
//   useSubmit: true;
// }
// type ApiSaveEduInfoResult = null;
// export async function saveEduInfo(req: ApiSaveEduInfoRequest) {
//   const resp = await request.post<BaseResponse<ApiSaveEduInfoResult>>(
//     "/api/v1/quotation/sale/saveEduInfo",
//     req
//   );
//   return resp.data;
// }
function _saveOcpInfo() { _saveOcpInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee19(req) { var resp; return _regeneratorRuntime.wrap(function _callee19$(_context19) { while (1) {
    switch (_context19.prev = _context19.next) {
        case 0:
            _context19.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveOcpInd/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context19.sent;
            return _context19.abrupt("return", resp.data);
        case 4:
        case "end": return _context19.stop();
    }
} }, _callee19); })); return _saveOcpInfo.apply(this, arguments); }
export function saveEduInfo(_x20) { return _saveEduInfo.apply(this, arguments); }
function _saveEduInfo() { _saveEduInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee20(req) { var resp; return _regeneratorRuntime.wrap(function _callee20$(_context20) { while (1) {
    switch (_context20.prev = _context20.next) {
        case 0:
            _context20.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveEdu/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context20.sent;
            return _context20.abrupt("return", resp.data);
        case 4:
        case "end": return _context20.stop();
    }
} }, _callee20); })); return _saveEduInfo.apply(this, arguments); }
export function saveFinInfo(_x21) { return _saveFinInfo.apply(this, arguments); }
function _saveFinInfo() { _saveFinInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee21(req) { var resp; return _regeneratorRuntime.wrap(function _callee21$(_context21) { while (1) {
    switch (_context21.prev = _context21.next) {
        case 0:
            _context21.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveFinInfo/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context21.sent;
            return _context21.abrupt("return", resp.data);
        case 4:
        case "end": return _context21.stop();
    }
} }, _callee21); })); return _saveFinInfo.apply(this, arguments); }
export function saveTaxInfo(_x22) { return _saveTaxInfo.apply(this, arguments); } // export interface ApiSaveAddrInfoRequest {
//   quoteNo: "{{quoteNo}}";
//   addressList: [
//     {
//       partyFlag: "1";
//       sameToMailAddr: "Y";
//       nationality: "HK";
//       permAddrCountryCode: "HK";
//       territoryCode: "HK";
//       districtCode: "Aberdeen";
//       mailAddr01: "mailAddr01";
//       mailAddr02: "mailAddr02";
//       mailAddr03: "mailAddr03";
//     }
//   ];
//   submitTime: "{{submitTime}}";
// }
// type ApiSaveAddrInfoResult = boolean;
function _saveTaxInfo() { _saveTaxInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee22(req) { var resp; return _regeneratorRuntime.wrap(function _callee22$(_context22) { while (1) {
    switch (_context22.prev = _context22.next) {
        case 0:
            _context22.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveTaxInfo/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context22.sent;
            return _context22.abrupt("return", resp.data);
        case 4:
        case "end": return _context22.stop();
    }
} }, _callee22); })); return _saveTaxInfo.apply(this, arguments); }
export function saveAddrInfo(_x23) { return _saveAddrInfo.apply(this, arguments); } // export interface ApiSaveOcrInfoRequest {
//   useSubmitTime: true;
//   birthday: string;
//   partyCName: string;
//   lastNameEn: string;
//   firstNameEn: string;
//   gender: string;
//   identifyNumber: string;
//   partyFlag: string;
//   quoteNo: string;
// }
function _saveAddrInfo() { _saveAddrInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee23(req) { var resp; return _regeneratorRuntime.wrap(function _callee23$(_context23) { while (1) {
    switch (_context23.prev = _context23.next) {
        case 0:
            _context23.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveAddressNat/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context23.sent;
            return _context23.abrupt("return", resp.data);
        case 4:
        case "end": return _context23.stop();
    }
} }, _callee23); })); return _saveAddrInfo.apply(this, arguments); } // type ApiSaveOcrInfoResult = boolean;
// export async function saveOcrInfo(req: ApiSaveOcrInfoRequest) {
//   const resp = await request.post<BaseResponse<ApiSaveOcrInfoResult>>(
//     "/api/v1/ekyc/saveOcrInfo",
//     {
//       ...req,
//       partyCName: req.partyCName ?? "",
//     }
//   );
//   return resp.data;
// }
// type ApiSaveOcrInfoResult = boolean;
export function saveOcrInfo(_x24) { return _saveOcrInfo.apply(this, arguments); } /*

{
    "policyNo":"{{policyNo}}",
    "proposalSId":"{{proposalSid}}",
    "successIndicator":"",
    "paymethod":"Q",
    "cardHolder":"",
    "idcardNum":"",
    "idcardType":"",
    "currency":"",
    "userId":"",
    "cardHolderFirstName":"",
    "cardHolderLastName":"",
    "cardNumber":"",
    "senderBankId":"",
    "branchCode":"",
    "jointAccountName":"",
    "exchangeRate":"7.75001",
    "bankTransferFlag":"",
    "accountNumber":"",
    "billAccNum":"",
    "accountName":"",
    "submitTime":"2021-07-12T23:28:56.782Z"
}
*/ // interface ApiNonCreditCardPaymentInfoChequeRequest {
//   useSubmitTime: true;
//   paymethod: "Q";
//   policyNo: string;
//   proposalSId: string;
//   exchangeRate: string;
//   successIndicator: "";
//   cardHolder: "";
//   idcardNum: "";
//   idcardType: "";
//   currency: "";
//   userId: "";
//   cardHolderFirstName: "";
//   cardHolderLastName: "";
//   cardNumber: "";
//   senderBankId: "";
//   branchCode: "";
//   jointAccountName: "";
//   bankTransferFlag: "";
//   accountNumber: "";
//   billAccNum: "";
//   accountName: "";
// }
// type ApiNonCreditCardPaymentInfoRequest =
//   ApiNonCreditCardPaymentInfoChequeRequest;
// interface ApiNonCreditCardPaymentInfoResult {
//   proposalSid: string;
//   policyNo: string;
//   result: string;
// }
function _saveOcrInfo() { _saveOcrInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee24(req) { var _req$partyCName; var resp; return _regeneratorRuntime.wrap(function _callee24$(_context24) { while (1) {
    switch (_context24.prev = _context24.next) {
        case 0:
            _context24.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/saveOcr/" + req.productCode, Object.assign({}, req, { productCode: undefined, partyCName: (_req$partyCName = req.partyCName) !== null && _req$partyCName !== void 0 ? _req$partyCName : "" }));
        case 2:
            resp = _context24.sent;
            return _context24.abrupt("return", resp.data);
        case 4:
        case "end": return _context24.stop();
    }
} }, _callee24); })); return _saveOcrInfo.apply(this, arguments); }
export function paymentConfirm(_x25, _x26, _x27, _x28) { return _paymentConfirm.apply(this, arguments); }
function _paymentConfirm() { _paymentConfirm = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee25(req, formState, equal, language) { var resp; return _regeneratorRuntime.wrap(function _callee25$(_context25) { while (1) {
    switch (_context25.prev = _context25.next) {
        case 0:
            _context25.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/paymentConfirm/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }), { headers: { "Accept-Language": language === "hk" ? "zh-HK" : language === "cn" ? "zh-CN" : "en-US" } });
        case 2:
            resp = _context25.sent;
            return _context25.abrupt("return", resp.data);
        case 4:
        case "end": return _context25.stop();
    }
} }, _callee25); })); return _paymentConfirm.apply(this, arguments); }
export function updateOcrPremium(_x29) { return _updateOcrPremium.apply(this, arguments); }
function _updateOcrPremium() { _updateOcrPremium = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee26(req) { var resp; return _regeneratorRuntime.wrap(function _callee26$(_context26) { while (1) {
    switch (_context26.prev = _context26.next) {
        case 0:
            _context26.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/updateOcrPremium/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context26.sent;
            return _context26.abrupt("return", resp.data);
        case 4:
        case "end": return _context26.stop();
    }
} }, _callee26); })); return _updateOcrPremium.apply(this, arguments); }
